import { Box, Typography } from "@mui/material";
import React from "react";
import { colors } from "../theme/Colors";
//imgs
import background from "../../src/imgs/squidGuy4.png";
import squidTitle from "../../src/imgs/squidGameTitle.svg";
import fantasiaLand from "../../src/imgs/fantasialand.svg";
import x from "../../src/imgs/triangle.svg";
import gagency from "../../src/imgs/gagency.png";
import { useLocation } from "react-router-dom";

function Success() {
  const location = useLocation();

  const place = location?.state?.place;
  const date = location?.state?.date;
  const time = location?.state?.time;

  console.log("location", location);
  console.log("place", place);
  console.log("date", date);
  console.log("time", time);

  return (
    <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" height="100vh" bgcolor="white">
      <Box marginBottom="32px" textAlign="center">
        <Typography fontSize="48px" fontFamily={"NeurialGrotesk-Bold"} color={"black"}>
          {place} - {date} à {time}
        </Typography>
        <Typography fontSize="20px" fontFamily={"NeurialGrotesk-Medium"} color="#767676">
          Avez-vous ce qu'il faut pour rester debout jusqu'à la fin ?
        </Typography>
      </Box>

      <Box sx={{ display: "flex", backgroundColor: colors.main, marginTop: "24px" }} width="350px" height="330px" borderRadius={"16px"} marginBottom="16px">
        <Box display="flex" alignItems="center" justifyContent="center" gap="64px" flexDirection="column" width="100%">
          <img style={{ width: "100px" }} src={squidTitle} alt="squidgame-title" />
          <img style={{ width: "280px" }} src={x} alt="x" />
        </Box>
      </Box>
      <Box maxWidth="400px" textAlign="center">
        <Typography fontSize="20px" fontFamily={"NeurialGrotesk-Medium"} color={colors.main}>
          Veuillez confirmer votre présence 48h à l'avance en appelant le
        </Typography>
        <Typography fontWeight={800} fontSize="20px" fontFamily={"NeurialGrotesk-Medium"} color={colors.main}>
          0559 34 31 38
        </Typography>
      </Box>

      <Box position="relative" sx={{ marginTop: "40px", width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: "16px" }}>
        <img style={{ objectFit: "cover", height: "78px" }} src={gagency} alt="G-Agency" />
        <Box display="flex" flexDirection="column" justifyContent="center">
          <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"12px"} color="#767676">
            contact@g-agency.dz
          </Typography>
          <Typography textAlign="center" fontFamily={"NeurialGrotesk-Regular"} fontSize={"12px"} color="#767676">
            +213 559 34 31 38
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}

export default Success;
